import 'remixicon/fonts/remixicon.css';
import data from '../assets/particles.json'
const tsParticles = require("tsparticles");
/* tsParticles.loadJSON(@dom-id, @path-json, @callback (optional)); */
tsParticles.tsParticles.load('tsparticles', data)
    .catch((error) => {
        console.error(error);
    });